var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 18,
    viewBox: "0 0 27 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2729_4267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1937 5.92316L25.1933 5.92346L24.393 6.48895L24.1959 6.62826L24.3282 6.83016C25.6675 8.87358 26.3807 11.232 26.3807 13.6945C26.3807 13.851 26.2536 13.978 26.0972 13.978C25.9408 13.978 25.8137 13.851 25.8137 13.6945C25.8137 11.356 25.1401 9.11399 23.8762 7.17135L23.7346 6.9537L23.5225 7.10345L16.5232 12.0446L16.3461 12.1696L16.4448 12.3626C16.6524 12.7688 16.778 13.2166 16.778 13.6945C16.778 15.3212 15.4538 16.6454 13.8271 16.6454C12.2004 16.6454 10.8762 15.3212 10.8762 13.6945C10.8762 12.0679 12.2004 10.7436 13.8271 10.7436C14.6166 10.7436 15.3325 11.0595 15.8652 11.5685L16.0139 11.7107L16.1821 11.592L23.6326 6.332C23.6336 6.33137 23.6345 6.33074 23.6354 6.33012C23.641 6.3266 23.6468 6.32269 23.6527 6.31834L24.8671 5.46123L24.8671 5.46125L24.8696 5.45948C24.9928 5.37023 25.1717 5.39926 25.2598 5.52699L25.2598 5.527L25.2614 5.52929C25.3516 5.65693 25.3212 5.83342 25.1937 5.92316ZM11.4432 13.6945C11.4432 15.0095 12.5122 16.0785 13.8271 16.0785C15.142 16.0785 16.211 15.0095 16.211 13.6945C16.211 12.3796 15.142 11.3106 13.8271 11.3106C12.5122 11.3106 11.4432 12.3796 11.4432 13.6945Z",
    fill: "white",
    stroke: "#585858",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6279 4.59508L21.6275 4.5948C19.4578 2.73128 16.6846 1.70486 13.8209 1.70486C7.2117 1.70486 1.8343 7.08226 1.8343 13.6915C1.8343 13.8479 1.70723 13.975 1.55082 13.975C1.39441 13.975 1.26733 13.8479 1.26733 13.6915C1.26733 6.76944 6.89888 1.13789 13.8209 1.13789C16.8202 1.13789 19.7241 2.21226 21.9972 4.16512C22.1163 4.26769 22.1298 4.44598 22.0275 4.56468L22.027 4.56528C21.9258 4.68341 21.7469 4.69766 21.6279 4.59508Z",
    stroke: "#585858",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2729_4267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.0326,
    height: 16.4274,
    fill: "white",
    transform: "translate(0.809814 0.677536)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.f1bef7caa16960eed1ea8d20d1786cdd.svg";
export { ForwardRef as ReactComponent };